module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N-window-background.f5b771e2.png";